<app-admin-header *ngIf="hasAccess(['ADMIN'])"></app-admin-header>
<app-mda-header *ngIf="hasAccess(['MDA'])"></app-mda-header>
<div class="container mt-4 px-5">
    <div class="card">
        <div class="card-body px-2">
            <div class="row mt-2 mb-3 px-4">
                <div class="col-md-12 text-center">
                    <h5 class="fw-bold fs-18 my-2">MDA Services Payment</h5>
                </div>
            </div>
            <div class="row justify">
                <form [formGroup]="asinForm">
                    <div class="col-md-4">
                        <label class="fw-bold fs-18 my-2">Enter Your ASIN</label>
                        <div class="input-group">
                            <input type="text" class="form-control  small-option-font" placeholder="Enter ASIN"
                                   formControlName="asin">
                            <div class="input-group-append text-left">
                                <button (click)="verifyTin()" class="btn custom-btn btn-sm fs-11">
                                    <ng-container *ngIf="searching">
                                        <span><span class="iconify icon"
                                                    data-icon="eos-icons:bubble-loading"></span></span>
                                    </ng-container>
                                    Verify ASIN
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>


            <ng-container *ngIf="hasPayerData">
                <div class="row justify-content-center mb-4 px-4">
                    <div class="col-md-12">
                        <div class="w-100">
                            <div class="my-3 fw-700 px-4 pt-2"
                                 style="position: relative;border: 1px solid #ccc;border-radius: 10px; background: #fff">
                                <b style="position: absolute; background: #fff; padding: 0 10px; top: -12px; left: 20px; border-radius: 5px;">Payer
                                    Details</b>

                                <form
                                        [formGroup]="form"
                                        autocomplete="off"
                                >
                                    <div>
                                        <div>
                                            <div class="row g-4 p-2 pb-5">
                                                <div class="col-md-6 col-lg-4">
                                                    <label class="form-label">Name</label>
                                                    <input
                                                            type="text"
                                                            class="form-control custom-input"
                                                            id="name"
                                                            formControlName="name"
                                                            placeholder="Enter full name"
                                                    />
                                                    <app-error-message
                                                            [form]="form"
                                                            [controlName]="'name'"
                                                    ></app-error-message>
                                                </div>
                                                <div class="col-md-6 col-lg-4">
                                                    <label class="form-label">ASIN</label>
                                                    <input
                                                            type="text"
                                                            class="form-control custom-input"
                                                            id="asin"
                                                            formControlName="asin"
                                                            placeholder="Enter ASIN"
                                                    />
                                                    <app-error-message
                                                            [form]="form"
                                                            [controlName]="'asin'"
                                                    ></app-error-message>
                                                </div>
                                                <div class="col-md-6 col-lg-4">
                                                    <label class="form-label "> Phone Number</label>
                                                    <div class="w-100 ">
                                                        <ngx-intl-tel-input
                                                                [cssClass]="'form-control custom-input w-100'"
                                                                [customPlaceholder]="'Phone Number'"
                                                                [enableAutoCountrySelect]="true"
                                                                [enablePlaceholder]="true"
                                                                [id]="'telephoneNumber'"
                                                                [maxLength]="15"
                                                                [phoneValidation]="true"
                                                                [preferredCountries]="preferredCountries"
                                                                [searchCountryField]="[SearchCountryField.Iso2,SearchCountryField.Name]"
                                                                [searchCountryFlag]="true"
                                                                [selectFirstCountry]="true"
                                                                [selectedCountryISO]="countryISO"
                                                                formControlName="phoneNumber"
                                                        ></ngx-intl-tel-input>
                                                        <app-error-message
                                                                [form]="form"
                                                                [controlName]="'phoneNumber'"
                                                        ></app-error-message>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-lg-4">
                                                    <label class="form-label ">Email</label>
                                                    <input
                                                            type="email"
                                                            class="form-control custom-input"
                                                            id="email"
                                                            formControlName="email"
                                                            placeholder="Enter email address"
                                                    />
                                                    <app-error-message
                                                            [form]="form"
                                                            [controlName]="'email'"
                                                    ></app-error-message>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>

                    <div class="col-md-12">
                        <form [formGroup]="mdaForm" autocomplete="off">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="required">MDA</label>
                                        <div class="input-group">
                                            <select *ngIf="mdaList$ | async as mdaList else loading"
                                                    class="form-control custom-select" formControlName="mda">
                                                <option [value]="d?.id" *ngFor="let d of mdaList">{{ d?.name }}
                                                </option>
                                            </select>

                                            <app-error-message
                                                    [form]="mdaForm"
                                                    [controlName]="'mda'"
                                            ></app-error-message>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="required">Revenue Name</label>
                                        <div class="input-group">
                                            <select *ngIf="mdaExtendedRevenue$ | async as mdaExtendedRevenue else loading" class="form-control custom-select" formControlName="revenueId">
                                                <option [value]="d?.id" *ngFor="let d of mdaExtendedRevenue">{{ d?.revenueName }}
                                                </option>
                                            </select>

                                            <app-error-message
                                                    [form]="mdaForm"
                                                    [controlName]="'revenueId'"
                                            ></app-error-message>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="required">Service Type</label>
                                        <div class="input-group">
                                            <input
                                                    type="text"
                                                    class="form-control custom-input"
                                                    formControlName="serviceType"
                                            />
                                        </div>
                                        <app-error-message
                                                [form]="mdaForm"
                                                [controlName]="'serviceType'"
                                        ></app-error-message>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <label class="required"
                                    >Transaction Amount</label
                                    >
                                    <input
                                            type="text"
                                            placeholder="Enter Amount"
                                            class="form-control custom-input"
                                            formControlName="transactionAmount"
                                    />
                                    <app-error-message
                                            [form]="mdaForm"
                                            [controlName]="'transactionAmount'"
                                    ></app-error-message>
                                </div>
                                <div class="col-md-3">
                                    <label class="required">Period Covered</label>
                                    <div class="input-group">
                                        <input
                                            #dp="bsDatepicker"
                                            bsDatepicker
                                            type="text"
                                            class="form-control"
                                            placeholder="1990"
                                            formControlName="paymentPeriod"
                                            [maxDate]="now()"
                                            [bsConfig]="{ dateInputFormat: 'YYYY', containerClass: 'theme-orange' }"
                                        />
                                        <span
                                                class="input-group-text bg-white"
                                                (click)="dp.toggle()"
                                        ><span class="iconify" data-icon="uil:calender"></span
                                        ></span>
                                    </div>
                                    <app-error-message
                                            [form]="mdaForm"
                                            [controlName]="'paymentPeriod'"
                                    ></app-error-message>
                                </div>
                                <div class="col-md-3">
                                    <label class="fw-bold fs-18 my-2">Transaction description</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control small-option-font"
                                               placeholder="Enter Description"
                                               formControlName="transactionDescription">
                                    </div>
                                    <app-error-message
                                            [form]="mdaForm"
                                            [controlName]="'transactionDescription'"
                                    ></app-error-message>
                                </div>
                                <div class="col-md-3 mt-4" *ngIf="!previewItems">
                                    <button [disabled]="mdaForm.invalid" (click)="preview()" style="font-size: 14px"
                                            class="btn btn-success btn-lg mt-3 rounded-0">
                                        <ng-container *ngIf="submitting">
                                          <span><span class="iconify icon" data-icon="eos-icons:loading"></span></span>
                                        </ng-container>
                                        Proceed
                                    </button>
                                </div>
                            </div>

                            <div *ngIf="previewItems" style="float: right">
                                        <button [disabled]="submitting" (click)="payment()" style="font-size: 14px"
                                                class="btn btn-success btn-lg mt-3 rounded-0">
                                            <ng-container *ngIf="submitting">
                                                <span><span class="iconify icon" data-icon="eos-icons:loading"></span></span>
                                            </ng-container>
                                            Proceed To Payment
                                        </button>
                                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                        <button [disabled]="submitting" (click)="downloadNotice()" style="font-size: 14px"
                                                class="btn btn-success btn-lg mt-3 rounded-0">
                                            <ng-container *ngIf="submitting">
                                                <span><span class="iconify icon" data-icon="eos-icons:loading"></span></span>
                                            </ng-container>
                                            Download Demand Notice
                                        </button>
                                </div>
                        </form>
                    </div>
                </div>
            </ng-container>

        </div>
    </div>
</div>
<ng-template #loading>
    <select class="form-control">
        <option [value]="''" disabled selected> Loading...</option>
    </select>
</ng-template>

<app-footer *ngIf="hasAccess(['ADMIN'])"></app-footer>
<app-mda-footer *ngIf="hasAccess(['MDA'])"></app-mda-footer>